const BackIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#FB325E"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M12 4a8 8 0 1 1 0 16"
    />
    <path
      stroke="#FB325E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14 12H4m0 0 3 3m-3-3 3-3"
    />
  </svg>
);
export default BackIcon;
